/**
 * Texts for header
 */
export const headerText = {
    cookiesIntroText: 'We use cookies to track website visits, but we do not store any personal information.',
    cookiesAccept: 'Accept cookies',
    cookiesDeny: 'Decline cookies',
    tabFAQs: 'FAQs',
    tabSupport: 'Support',
    tabHistory: 'History',
    tabReviews: 'Stories',
    tabTraining: 'Training',
    tabUserTraining: 'User Training',
    tabHcpTraining: 'HCP training',
    tabCamAPSLiberty: 'CamAPS Liberty',
    tabPregnancy: 'Pregnancy',
    tabAbout: 'About',
    tabNews: 'News',
    tabCareers: 'Careers',
    tabOrders: '',
    tabNotifications: 'Notifications',
};
